var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ws-search-form',{staticClass:"ws-de-center__search",attrs:{"placeholder":_vm.$t('Наименование ЦПДЭ')}})
}
var staticRenderFns = []

export { render, staticRenderFns }